{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Olet ylittänyt keskustelurajan. Hacker-paketti sallii vain 500 keskustelua.",
      "INBOXES": "Olet ylittänyt saapuneet-kansioiden rajan. Hacker-paketti tukee vain verkkosivun live-chattia. Muut saapuneet-kansiot, kuten sähköposti ja WhatsApp, vaativat maksullisen paketin.",
      "AGENTS": "Olet ylittänyt edustajien rajan. Hacker-paketti sallii vain 2 edustajaa.",
      "NON_ADMIN": "Ota yhteyttä pääkäyttäjääsi paketin päivittämiseksi, jotta voit jatkaa kaikkien ominaisuuksien käyttöä."
    },
    "TITLE": "Tilin asetukset",
    "SUBMIT": "Päivitä asetukset",
    "BACK": "Takaisin",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Asetuksia ei voitu päivittää, yritä uudelleen",
      "SUCCESS": "Tilin asetukset päivitetty onnistuneesti"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Poista tilisi",
      "NOTE": "Kun poistat tilisi, kaikki tietosi poistetaan.",
      "BUTTON_TEXT": "Poista tilisi",
      "CONFIRM": {
        "TITLE": "Poista tili",
        "MESSAGE": "Tilin poistaminen on peruuttamatonta. Vahvista pysyvä poistaminen kirjoittamalla tilisi nimi alle.",
        "BUTTON_TEXT": "Poista",
        "DISMISS": "Peruuta",
        "PLACE_HOLDER": "Kirjoita {accountName} vahvistaaksesi"
      },
      "SUCCESS": "Tili merkitty poistettavaksi",
      "FAILURE": "Tiliä ei voitu poistaa, yritä uudelleen!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Tämä tili on ajastettu poistettavaksi {deletionDate}. Poiston pyysi pääkäyttäjä. Voit peruuttaa poiston ennen tätä päivämäärää.",
        "MESSAGE_INACTIVITY": "Tämä tili on ajastettu poistettavaksi {deletionDate} tilin käyttämättömyyden vuoksi. Voit peruuttaa poiston ennen tätä päivämäärää.",
        "CLEAR_BUTTON": "Peruuta ajastettu poisto"
      }
    },
    "FORM": {
      "ERROR": "Korjaa lomakkeen virheet",
      "GENERAL_SECTION": {
        "TITLE": "Yleiset asetukset",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Tilin nimi",
        "PLACEHOLDER": "Tilisi nimi",
        "ERROR": "Anna kelvollinen tilin nimi"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Tilisi nimi",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Saapuvan sähköpostin verkkotunnus",
        "PLACEHOLDER": "Verkkotunnus, jonne saat sähköpostit",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Tukisähköposti",
        "PLACEHOLDER": "Yrityksesi tukisähköposti",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Kuinka monen päivän jälkeen tukipyyntö suljetaan automaattisesti, mikäli sillä ei ole toimintaa",
        "NOTE": "Tuntien määrä, jonka jälkeen avoin keskustelu ratkaistaan automaattisesti käyttämättömyyden vuoksi.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Päivien määrä, jonka jälkeen tyhjä keskustelu ratkaistaan automaattisesti, mikäli sillä ei ole toimintaa",
        "PLACEHOLDER": "ei koskaan",
        "ERROR": "Anna kelvollinen automaattisen ratkaisun aika (vähintään 1 päivä ja enintään 999 päivää)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Keskustelun jatkuvuus sähköpostin kautta on käytössä tililläsi.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Voit nyt vastaanottaa sähköposteja mukautetulla verkkotunnuksellasi."
      },
      "PHONE": {
        "TITLE": "Puhelinvaihteen asetukset",
        "NOTE": "Määritä yhteys puhelinvaihteeseesi puheluita varten",
        "SIP_HOST": {
          "LABEL": "SIP-verkkotunnus"
        },
        "DIALING_MODE": {
          "LABEL": "Soittotila",
          "MODES": {
            "direct": "Suora – puhelu soitetaan heti, kun puhelinlinkkiä napsautetaan",
            "indirect": "Epäsuora – puhelinnumero valmistellaan puhelinwidgetin syöttökenttään"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Puhelutallenteiden käyttöoikeus",
          "MODES": {
            "admin_only": "Vain pääkäyttäjät",
            "admin_and_assigned_agent": "Pääkäyttäjät ja määritetty edustaja",
            "inbox_members": "Kaikki edustajat, joilla on pääsy saapuneet-kansioon"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Sähköpostiasetukset",
        "NOTE": "Muuttaa sähköpostin saapuneet-kansioiden toimintaa"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Keskustelun aikaleiman näyttötapa",
        "MODES": {
          "both": "Luotu ja viimeisin toiminta",
          "last_activity_only": "Vain viimeisin toiminta",
          "last_customer_message": "Viimeisin asiakkaan viesti"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Estä maineeltaan huonot verkkotunnukset"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Sisällytä alkuperäinen viesti sähköpostivastaukseen"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Ratkaise uusi keskustelu automaattisesti"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Siirrä uusi sähköpostikeskustelu automaattisesti sen robotin postilaatikkoon, joka käsitteli yhteyshenkilön tilaukset"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Laajennetut tunnisteet – salli pidemmät tunnisteiden nimet suuremmalla ponnahdusikkunalla"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent – määritä keskustelu automaattisesti edustajalle, joka lähetti viimeisimmän vastauksen"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Push-ilmoitusten tila",
        "MODES": {
          "all_inboxes": "Kaikki saapuneet-kansiot – lähetä ilmoitukset kaikista kanavatyypeistä",
          "chat_only": "Vain chat – lähetä ilmoitukset vain muista kuin sähköpostikanavista"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Salli allekirjoituksen kytkeminen lähetetyissä viesteissä"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Näytä edustajan chat-tila wallboardilla"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Näytä liitteiden koko nimet lyhentämättä"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Salasanakirjautuminen",
        "MODES": {
          "allowed_for_all": "Sallittu kaikille käyttäjille",
          "allowed_for_agents_only": "Sallittu vain edustajille (pääkäyttäjien on käytettävä OAuthia)",
          "password_login_disabled": "Pois käytöstä – vain OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Uusi versio saatavilla. Lataa sivu uudelleen saadaksesi viimeisimmät päivitykset.",
    "RELOAD_NOW": "Päivitä nyt",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Maksusi odottaa käsittelyä. Päivitä maksutietosi, jotta voit jatkaa tämän ohjelmiston käyttöä",
    "LIMITS_UPGRADE": "Tilisi on ylittänyt käyttörajat. Päivitä tilauksesi, jotta voit jatkaa tämän ohjelmiston käyttöä",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Paina enter valitaksesi",
      "ENTER_TO_REMOVE": "Paina enter poistaaksesi",
      "NO_OPTIONS": "Lista on tyhjä",
      "NO_RESULT": "Tuloksia ei löytynyt",
      "SELECT_ONE": "Valitse yksi",
      "SELECT": "Valitse"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Ilmoitukset",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Nimi",
        "Puhelinnumero",
        "Keskustelut",
        "Viimeksi otettu yhteyttä"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Uusi keskustelu",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Yhteys katkesi",
      "DESCRIPTION": "Palvelimeen ei saatu yhteyttä. Tarkista yhteytesi ja yritä uudelleen.",
      "RETRY": "Yritä uudelleen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Raportit",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Suorita makro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Asetukset",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Suorita makro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Avaa keskustelu uudelleen",
      "RESOLVE_CONVERSATION": "Selvitä keskustelu",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "klikkaa tästä"
  }
}
